import React from "react";

function IconRobot() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 7A2.75 2.75 0 014 4.25h12A2.75 2.75 0 0118.75 7v8A2.75 2.75 0 0116 17.75H4A2.75 2.75 0 011.25 15V7zM4 5.75c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25H4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 13.25a.75.75 0 01.75-.75h2.5a.75.75 0 010 1.5h-2.5a.75.75 0 01-.75-.75z"
      />
      <path d="M8 10a1 1 0 11-2 0 1 1 0 012 0zM14 10a1 1 0 11-2 0 1 1 0 012 0zM11.5 1.75a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0z" />
      <path d="M9 2h1.5v3H9V2z" />
    </svg>
  );
}

export default IconRobot;
